import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PackageService } from '../../../shared/services/superadminusers/plan.service';
import { Package } from '../../../models/package.model';
import { Router } from '@angular/router';
import { SeoService } from '../../../shared/services/seo.service';
import { amountChange } from '../../../shared/services/utils/utils';
import { formatUSD } from '../../../consts/utils';

@Component({
  selector: 'app-package-comparison',
  imports: [CommonModule],
  templateUrl: './package-comparison.component.html',
  styleUrl: './package-comparison.component.scss'
})
export class PackageComparisonComponent {
  packages: Package[] = [];

  constructor(private _packageService: PackageService, private router: Router, private seo: SeoService) {
    /**
   * Sets up SEO meta tags using SeoService
   * This helps in optimizing the page for search engines and social media previews.
*/
    this.seo.setTags({
      title: 'Home Package component', // Title
      titleSuffix: '- Shining On Safety', // Title Suffix
      description: 'Shining On Safety', // Description
      image: '', // Image
      keywords: 'Shining On Safety' // Keywords
    });
  }

  ngOnInit(): void {
    this.getAllPlans();
  }

  getAllPlans() {
    this._packageService.getAllPlans().subscribe({
      next: (res) => {
        this.packages = res.data;    
        
      },
      error: (error) => {
      },
    })
  }

  choosePackage(pkg: Package) {
    this.router.navigate(['/company-registration', pkg._id]);
  }

  setFormat(data: any){
    return formatUSD(data);
  }

}
